<template>
<b-card class="mb-1">
  <div class="editor">
    <editor-menu-bar :editor="editor" v-slot="{ commands, isActive }" class="menubar bg-light">
      <div class="menubar">
        <b-button class="menubar__button" variant="transparent" :class="{ 'is-active': isActive.bold() }" @click="commands.bold">
          <bold-icon id="icons" />
        </b-button>
        <b-button class="menubar__button" variant="transparent" :class="{ 'is-active': isActive.italic() }" @click="commands.italic">
          <italic-icon id="icons" />
        </b-button>
        <b-button class="menubar__button" variant="transparent" :class="{ 'is-active': isActive.strike() }" @click="commands.strike">
          <strike-icon id="icons" />
        </b-button>
        <b-button class="menubar__button" variant="transparent" :class="{ 'is-active': isActive.underline() }" @click="commands.underline">
          <underline-icon id="icons" />
        </b-button>
        <b-button class="menubar__button" variant="transparent" :class="{ 'is-active': isActive.heading({ level: 1 }) }" @click="commands.heading({ level: 1 })">
          H1
        </b-button>
        <b-button class="menubar__button" variant="transparent" :class="{ 'is-active': isActive.heading({ level: 2 }) }" @click="commands.heading({ level: 2 })">
          H2
        </b-button>
        <b-button class="menubar__button" variant="transparent" :class="{ 'is-active': isActive.heading({ level: 3 }) }" @click="commands.heading({ level: 3 })">
          H3
        </b-button>
        <b-button class="menubar__button" variant="transparent" :class="{ 'is-active': isActive.bullet_list() }" @click="commands.bullet_list">
          <ul-icon id="icons" />
        </b-button>
        <b-button class="menubar__button" variant="transparent" :class="{ 'is-active': isActive.ordered_list() }" @click="commands.ordered_list">
          <ol-icon id="icons" />
        </b-button>
        <b-button class="menubar__button" variant="transparent" @click="showImagePrompt(commands.image)">
          Image
        </b-button>
      </div>
    </editor-menu-bar>
    <editor-content class="editor__content" :editor="editor" />
  </div>
  <template v-slot:footer>
    <b-button variant="success" @click="addComment()">Enregistrer Commentaire</b-button>
</template>
</b-card>
</template>

<script>
import { Editor, EditorContent, EditorMenuBar } from 'tiptap'
import BoldIcon from '../icons/tip-tap-icons/BoldIcon'
import ItalicIcon from '../icons/tip-tap-icons/ItalicIcon'
import StrikeIcon from '../icons/tip-tap-icons/StrikeIcon'
import UnderlineIcon from '../icons/tip-tap-icons/UnderlineIcon'
import OlIcon from '../icons/tip-tap-icons/OlIcon'
import UlIcon from '../icons/tip-tap-icons/UlIcon'

import {
  HardBreak,
  Heading,
  Image,
  OrderedList,
  BulletList,
  ListItem,
  TodoItem,
  TodoList,
  Bold,
  Italic,
  Strike,
  Underline,
} from 'tiptap-extensions'

export default {
  components: { Editor, EditorContent, EditorMenuBar, BoldIcon, ItalicIcon, StrikeIcon, UnderlineIcon, OlIcon, UlIcon },
  props: ['commentToEdit'],
  data() {
    return {
      editorContent: 'Tapez votre commentaire',
      editor: new Editor({
        extensions: [
          new BulletList(),
          new HardBreak(),
          new Image(),
          new Heading({ levels: [1, 2, 3] }),
          new ListItem(),
          new OrderedList(),
          new TodoItem(),
          new TodoList(),
          new Bold(),
          new Italic(),
          new Strike(),
          new Underline(),
        ],
        onUpdate: ({ getHTML }) => {
          // get new content on update
          this.editorContent = getHTML()
        },
      }),
    }
  },
  created() {
    if (this.commentToEdit) {
      this.editor.setContent(this.commentToEdit)
    } else {
      this.editor.setContent(this.editorContent)
    }
  },
  methods: {
    addComment: function() {
      if (this.editorContent != 'Tapez votre commentaire') {
        this.$emit('addComment', this.editorContent)
      }
    },
    // Envoie l'évènement au composant parent pour fermeture de la création de commentaire
    showOrHideEditorComment: function() {
      this.$emit('showOrHideEditorComment')
    },
    // Gestion de l'import d'images
    showImagePrompt(command) {
      const src = prompt('Copier l\'url vers l\'image ici')
      if (src !== null) {
        command({ src })
      }
    },
    beforeDestroy() {
      this.editor.destroy()
    }
  }
}
</script>
<style>
.editor {
  height: 40em;
}

.menubar {
  padding: 15px;
}

.editor__content {
  height: 20em;
  color: black;
  border: 1px solid;
  padding: 25px;
}
</style>



// WEBPACK FOOTER //
// src/components/commons/EditorComment.vue